import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=34b64d6e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=34b64d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b64d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b64d6e')) {
      api.createRecord('34b64d6e', component.options)
    } else {
      api.reload('34b64d6e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=34b64d6e&scoped=true&", function () {
      api.rerender('34b64d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26pe8GTqxa6Ls/JS/comp/PopupDialog.vue"
export default component.exports